import { AccountSecretaryStudentDocumentsApi } from '../../src/_api/ilerna-StudentAccount/src'
import { asyncLazySingleton } from '../_common/common';

export const documentos = new asyncLazySingleton(async () => new AccountSecretaryStudentDocumentsApi());
